export const modifierList = [
  '2-cols',
  '2-cols-m',
  '2-cols-t',
  '2-cols-d',
  '3-cols',
  '3-cols-m',
  '3-cols-t',
  '3-cols-d',
];
